import { Link } from 'react-router-dom';

export default function SoyItPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-[#F5E6E0] sticky top-0 z-50">
        <div className="container mx-auto px-6 py-4">
          <span className="font-bold text-xl text-[#bc6355]">SOY it protein</span>
        </div>
      </header>

      {/* Breadcrumb */}
      <nav className="bg-[#FFF9F7] border-b border-[#F5E6E0]">
        <div className="container mx-auto px-6 py-3">
          <ul className="flex items-center gap-2 text-sm">
            <li>
              <a href="https://soyproteinranking.com/" className="flex items-center gap-2 text-[#D4A59A] hover:text-[#bc6355] transition-colors whitespace-nowrap">
                <span className="w-4 h-4 flex items-center justify-center text-[#bc6355]">
                  <i className="ri-home-4-line"></i>
                </span>
                <span>トップ</span>
              </a>
            </li>
            <li className="text-[#E8D4CF]">/</li>
            <li className="text-[#6B5750] whitespace-nowrap">SOY it proteinで理想の自分をデザインする</li>
          </ul>
        </div>
      </nav>

      {/* Main Content */}
      <main className="container mx-auto px-6 py-12 max-w-4xl">
        {/* Hero Section */}
        <div className="mb-12">
          <h1 className="text-3xl font-bold text-white mb-6 bg-gradient-to-r from-[#bc6355] to-[#D4A59A] px-6 py-4 rounded-lg leading-tight">
            SOY it proteinで理想の自分をデザインする
          </h1>
          
          <p className="text-[#6B5750] leading-relaxed mb-4">
            「お腹の脂肪が気になる」「無理な食事制限はしたくない」「美味しいプロテインで健康的に痩せたい」と考えたことはありませんか？
          </p>
          
          <p className="text-[#6B5750] leading-relaxed">
            <span className="text-[#bc6355] font-semibold underline decoration-[#F5E6E0] decoration-4">SOY it protein（そいっとプロテイン）</span>は、
            <span className="border-b-2 border-[#bc6355] font-semibold">機能性表示食品として認められた成分</span>を配合し、
            日常の動きをダイエットに変える次世代のソイプロテインです。
          </p>
        </div>

        {/* Feature Section */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#6B5750] mb-6 pb-3 border-b-4 border-[#bc6355]">
            SOY itの特徴や概要
          </h2>
          
          <p className="text-[#6B5750] leading-relaxed mb-6">
            <span className="text-[#bc6355] font-semibold">SOY it protein</span>は、ファンファレが提供する、
            「科学的根拠」と「継続のしやすさ」に特化したダイエットサポートプロテインです。
          </p>
          
          <p className="text-[#6B5750] leading-relaxed mb-8">
            最大の特徴は、肥満気味な方の体重やお腹の脂肪を減らすのを助ける
            <span className="border-b-2 border-[#bc6355] font-semibold">「葛の花由来イソフラボン」を配合</span>している点です。
            さらに、バリスタ監修の本格カフェラテ味を実現し、無理なく続けられる仕組みが整っています。
          </p>

          {/* Quick Overview */}
          <h3 className="text-xl font-bold text-[#6B5750] mb-6">SOY itがひと目でわかる！</h3>
          
          <div className="overflow-hidden rounded-lg border border-[#F5E6E0] shadow-sm mb-8 bg-white">
            <table className="w-full">
              <thead>
                <tr className="bg-[#FFF9F7]">
                  <th className="px-6 py-4 text-left text-sm font-semibold text-[#6B5750] border-b border-[#F5E6E0] w-1/3">項目</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-[#6B5750] border-b border-[#F5E6E0]">内容</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-[#F5E6E0]">
                <tr className="hover:bg-[#FFF9F7] transition-colors">
                  <td className="px-6 py-4 bg-[#bc6355] text-white font-semibold text-sm">主な機能性</td>
                  <td className="px-6 py-4 text-[#6B5750] text-sm">お腹の脂肪・体重を減らすのを助ける</td>
                </tr>
                <tr className="hover:bg-[#FFF9F7] transition-colors">
                  <td className="px-6 py-4 bg-[#bc6355] text-white font-semibold text-sm">注目成分</td>
                  <td className="px-6 py-4 text-[#6B5750] text-sm">葛の花由来イソフラボン / 大豆タンパク</td>
                </tr>
                <tr className="hover:bg-[#FFF9F7] transition-colors">
                  <td className="px-6 py-4 bg-[#bc6355] text-white font-semibold text-sm">カロリー</td>
                  <td className="px-6 py-4 text-[#6B5750] text-sm">1杯（10g）あたり驚きの38kcal</td>
                </tr>
                <tr className="hover:bg-[#FFF9F7] transition-colors">
                  <td className="px-6 py-4 bg-[#bc6355] text-white font-semibold text-sm">美容成分</td>
                  <td className="px-6 py-4 text-[#6B5750] text-sm">1日分のビタミン・鉄分・100億個の乳酸菌</td>
                </tr>
                <tr className="hover:bg-[#FFF9F7] transition-colors">
                  <td className="px-6 py-4 bg-[#bc6355] text-white font-semibold text-sm">利便性</td>
                  <td className="px-6 py-4 text-[#6B5750] text-sm">シェイカー不要！コップでサッと溶ける</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Usage Points Section */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#6B5750] mb-6 pb-3 border-b-4 border-[#bc6355]">
            SOY itの活用ポイント
          </h2>

          <div className="mb-8">
            <h4 className="text-lg font-bold text-[#6B5750] mb-4 border-b-2 border-[#F5E6E0] pb-2 inline-block">
              1.「葛の花由来イソフラボン」のパワー
            </h4>
            <p className="text-[#6B5750] leading-relaxed">
              脂肪の分解・燃焼をサポートし、日常の家事や通勤をダイエット時間に変えます。<strong className="text-[#bc6355]">「内臓脂肪」と「皮下脂肪」</strong>の両方にアプローチできるのが強みです。
            </p>
          </div>

          <div className="mb-8">
            <h4 className="text-lg font-bold text-[#6B5750] mb-4 border-b-2 border-[#F5E6E0] pb-2 inline-block">
              2.置き換え不要！「今の食事」にプラス
            </h4>
            <p className="text-[#6B5750] leading-relaxed">
              <strong className="text-[#bc6355]">1杯たったの38kcal</strong>なので、無理な制限は不要。低脂質なソイプロテインが腹持ちを助け、ついつい食べ過ぎてしまうのを防ぎます。
            </p>
          </div>

          <div className="mb-8">
            <h4 className="text-lg font-bold text-[#6B5750] mb-4 border-b-2 border-[#F5E6E0] pb-2 inline-block">
              3.バリスタ監修の「続けたくなる美味しさ」
            </h4>
            <p className="text-[#6B5750] leading-relaxed">
              プロテイン特有の飲みにくさを解消した、本格的な<strong className="text-[#bc6355]">カフェラテ味</strong>。デザート感覚で楽しみながら「継続」という一番高いハードルをクリアできます。
            </p>
          </div>
        </section>

        {/* Recommended For Section */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#6B5750] mb-6 pb-3 border-b-4 border-[#bc6355]">
            SOY itはこんな人におすすめ
          </h2>
          
          <div className="bg-gradient-to-br from-[#FFF9F7] to-[#FFF5F2] rounded-xl p-8 border border-[#F5E6E0] shadow-sm">
            <div className="flex items-center justify-center mb-6">
              <span className="bg-[#bc6355] text-white px-4 py-2 rounded-full text-sm font-bold">CHECK!</span>
            </div>
            <ol className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#bc6355] text-white flex items-center justify-center text-sm font-semibold mt-0.5">1</div>
                <p className="text-[#6B5750]">BMIが高めで、お腹周りの脂肪を本気で減らしたい</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#bc6355] text-white flex items-center justify-center text-sm font-semibold mt-0.5">2</div>
                <p className="text-[#6B5750]">激しい運動や、ツライ食事制限は長続きしない</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#bc6355] text-white flex items-center justify-center text-sm font-semibold mt-0.5">3</div>
                <p className="text-[#6B5750]">筋肉を維持しながら、低カロリーで健康的に引き締めたい</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#bc6355] text-white flex items-center justify-center text-sm font-semibold mt-0.5">4</div>
                <p className="text-[#6B5750]">美容成分（ビタミン・乳酸菌・鉄分）も効率よく摂りたい</p>
              </li>
            </ol>
          </div>
        </section>

        {/* Summary Section */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#6B5750] mb-6 pb-3 border-b-4 border-[#bc6355]">
            まとめ
          </h2>
          
          <div className="bg-gradient-to-br from-[#FFF9F7] to-[#FFF5F2] rounded-xl p-8 border border-[#F5E6E0] shadow-sm">
            <div className="flex items-center justify-center mb-6">
              <span className="bg-[#bc6355] text-white px-4 py-2 rounded-full text-sm font-bold">POINT</span>
            </div>
            <div className="space-y-4 text-[#6B5750]">
              <p className="flex items-start gap-2">
                <span className="text-[#bc6355] font-bold">•</span>
                <span><strong className="text-[#bc6355]">機能性表示食品:</strong> 葛の花由来イソフラボンがお腹の脂肪にアプローチ</span>
              </p>
              <p className="flex items-start gap-2">
                <span className="text-[#bc6355] font-bold">•</span>
                <span><strong className="text-[#bc6355]">超低カロリー:</strong> 1杯38kcalでダイエット中の間食にも最適</span>
              </p>
              <p className="flex items-start gap-2">
                <span className="text-[#bc6355] font-bold">•</span>
                <span><strong className="text-[#bc6355]">手軽に習慣化:</strong> シェイカー不要で溶けやすく、忙しい朝にも便利</span>
              </p>
            </div>
          </div>

          <p className="text-[#6B5750] leading-relaxed mt-8 text-center font-bold">
            「飲む、自己投資」で、迷いのないボディメイクを始めてみませんか。
          </p>

          {/* Banner */}
          <a 
            href="https://soyproteinranking.com/web/SOYit.php?p=sh" 
            target="_blank" 
            rel="noopener noreferrer"
            className="block mt-12 cursor-pointer hover:opacity-90 transition-opacity"
          >
            <img 
              src="https://static.readdy.ai/image/c28b677376caa266f389c59db123aec1/89c8b4abb18bdf6080fbf335e0f9d6f8.png" 
              alt="SOY it protein - 日本初のプロテインラテ" 
              className="w-full h-auto rounded-lg shadow-md"
            />
          </a>

          {/* CTA Section */}
          <div className="mt-8 bg-[#bc6355] rounded-lg py-8 px-6 text-center">
            <p className="text-white text-sm font-medium mb-4 tracking-wide">シリーズ累計1,200万個突破</p>
            
            {/* Logo */}
            <a 
              href="https://soyproteinranking.com/web/SOYit.php?p=sh" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-block bg-[#FFF9F7] rounded-lg px-8 py-4 mb-6 cursor-pointer hover:shadow-lg transition-shadow"
            >
              <p className="text-[#8B7B74] text-xs mb-1">そいっと。プロテイン</p>
              <p className="text-[#bc6355] text-2xl font-bold tracking-wide">SOY it</p>
              <p className="text-[#bc6355] text-xs tracking-widest">protein</p>
            </a>
            
            {/* CTA Button with shine animation */}
            <div>
              <a 
                href="https://soyproteinranking.com/web/SOYit.php?p=sh" 
                target="_blank" 
                rel="noopener noreferrer"
                className="relative inline-block bg-white text-[#bc6355] font-bold py-4 px-12 rounded-full cursor-pointer hover:shadow-lg transition-all overflow-hidden group"
              >
                <span className="relative z-10">SOY it proteinの詳細を見る</span>
                {/* Shine effect */}
                <span className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/60 to-transparent skew-x-[-20deg] animate-shine"></span>
              </a>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
